export const DELIVERY_METHODS = [
  { label: 'UPS', value: 'ups' },
  { label: 'DHL', value: 'dhl' },
  { label: 'Go', value: 'go' },
];
